import { ThemeOverride } from '@chakra-ui/react';

const tokens: ThemeOverride['semanticTokens'] = {
  colors: {
    bg_main_container: {
      _light: 'amatrium.700',
      _dark: 'grey.800',
    },
    bg_box: {
      _light: 'white',
      _dark: 'grey.700',
    },
    bg_main_input: {
      _light: 'white',
      _dark: 'grey.600',
    },
    bg_conversation_item: {
      _light: 'inherit',
      _dark: 'grey.700',
    },
    bg_conversation_item_select: {
      _light: 'whiteAlpha.700',
      _dark: 'grey.600',
    },
    color_main_text: {
      _light: 'grey.900',
      _dark: 'grey.50',
    },
    color_amatrium_text: {
      _light: 'amatrium.800',
      _dark: 'grey.50',
    },
    menu_item_option: {
      _light: 'white',
      _dark: 'grey.500',
    },
    menu_item_option_hover: {
      _light: 'gray.100',
      _dark: 'grey.400',
    },
    bg_icon: {
      _light: 'green.400',
      _dark: 'grey.50',
    },
  },
  shadows: {
    shadow_box: {
      _light: '0px 4px 4px 0px rgba(0, 0, 0, 0.25)',
      _dark: '',
    },
    outline: {
      _light: 'none',
      _dark: 'none',
    },
  },
  borders: {
    border_selected_box: {
      _light: 'none',
      _dark: 'solid white 1px',
    },
    border_dashed_box: {
      _light: 'none',
      _dark: 'dashed white 2px',
    },
    border_table_grid: {
      _light: 'solid black 1px',
      _dark: 'solid white 1px',
    },
    border_gray_solid: {
      _light: 'solid 1px #E2E8F0',
      _dark: 'none',
    },
    border_main: {
      _light: 'solid 2px #7963FF',
      _dark: 'solid 2px #ffffff',
    },
    border_main_summary: {
      _light: 'solid 2px #10a37f',
      _dark: 'solid 2px #ffffff',
    },
  },
};

export default tokens;
